import {
  collection, query, where, orderBy, onSnapshot,
} from 'firebase/firestore';
import { db } from '../../lib/firebase';

// Live per-lead audit trail for the Lead Drawer "System audit" tab.
// auditLogs is append-only + server-written; read is tenant-scoped (rules).
// Needs composite index: auditLogs (tenantId ASC, docId ASC, ts DESC).
export function subscribeLeadAudit(tenantId, leadId, onChange, onError) {
  if (!tenantId || !leadId) { onChange([]); return () => {}; }
  const q = query(
    collection(db, 'auditLogs'),
    where('tenantId', '==', tenantId),
    where('docId', '==', leadId),
    orderBy('ts', 'desc'),
  );
  return onSnapshot(
    q,
    (snap) => onChange(snap.docs.map((d) => ({ id: d.id, ...d.data() }))),
    (e) => (onError ? onError(e) : console.error('lead audit listener error', e)),
  );
}
